import React from 'react';
import { Paper,ListSubheader } from '@mui/material';
import { DataState, isDataLoaded } from '../../types';
import { DataIndicators } from '../DataIndicators';
import { usePPCGraphDetails } from '../../data/DataProviders/PPCGraphDataProvider';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { INStrendData } from '../../types/device';
import { ReusableTrendsGraph } from '../ReusableTrendsGraph';
export const PPCGraph: React.FC<{ monthValue: number }> = (props) => {
    const classes = chartLabelNameStyle();
    const ppcResponseData = usePPCGraphDetails();
    const isEmpty = isDataLoaded(ppcResponseData) ? ppcResponseData.value.channelsData.length === 0 : false;
   const ppcGraphlabelName = props.monthValue === 0
                                    ? '3 month daily maximum Pulse Repetition Rate (Pulses Per Cycle)'
                                    : '12 month daily maximum Pulse Repetition Rate (Pulses Per Cycle)';
  
    const [maxQmaxTrend, setmaxQmaxTrend] = React.useState<INStrendData>({ state: DataState.Loading });
    const tickInterval = props.monthValue === 0 ? 336 * 3600 * 1000 : 744 * 3600 * 1000;
    const ppcData: any = [];

    React.useEffect(() => {
        if (isDataLoaded(ppcResponseData)) {
            const deviceId = isDataLoaded(ppcResponseData) ? ppcResponseData.value.deviceId : '';
            const deviceName = isDataLoaded(ppcResponseData) ? ppcResponseData.value.deviceName : '';
            ppcResponseData.value.channelsData.map((item) => {
                const maxPPCObj = {
                    id: item.channelNumber,
                    deviceId: deviceId,
                    deviceName: deviceName,
                    channelName: item.channelName,
                    value: item.ppcChartData.map((val) => ({
                        dateTime: new Date(`${val.dateTime}`).toISOString(),
                        value: val.maxPpc,
                    })),
                    unit: '',
                };
                ppcData.push(maxPPCObj);
            });

            setmaxQmaxTrend({
                state: DataState.Loaded,
                value: ppcData,
            });
        }
    }, [ppcResponseData]);  
/* eslint-disable */
    const downloadCSV = (): void => {};

    return (
        <div data-testid="device-info-Ppc">
            <Paper style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={ppcResponseData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>
            {isDataLoaded(ppcResponseData) && (
                <>
                    {ppcResponseData.value.channelsData.length > 0 && (
                        <Paper elevation={0} variant="outlined">
                            <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                    {ppcGraphlabelName}
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon}/>}
                                    </span>
                                </ListSubheader>
                              
                            </div>

                            <ReusableTrendsGraph
                                large
                                trendsData={maxQmaxTrend}
                                downloadCSV={downloadCSV}
                                Inactive = {true}
                                tickInterval = {tickInterval}
                            />

                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
